import * as React from "react";
import PedidoSelectForm2 from "../components/PedidoSelectForm2.js";

function PedidoSelect() {
  return <PedidoSelectForm2 />;
}

export default PedidoSelect;
